//import StatisticsIndicatorMeta from './statistics-metabox'
//import StatisticsChart from './statistics-chart'
import 'jquery.scrollto'

function StatisticsTableMarking($statisticsWrap, $table, opt_opts){

	$table.on("click", "td", function (e) {
		$(this).toggleClass("marked")
	})
}
function StatisticsTableAnchors($statisticsWrap, tableScroll, opt_opts){
	opt_opts = opt_opts || {};
	var that = this;
	this.tableScroll = tableScroll;
	this.$statisticsWrap = $statisticsWrap;
	this.onWindowHashchange = function (e) {
		e.preventDefault();
		that.scrollToIndicator(location.hash);
	}

	window.addEventListener("hashchange", this.onWindowHashchange);

	$(".anchors a", $statisticsWrap).click(function (e) {
		that.scrollToIndicator($(this).attr("href"))
	})
}

StatisticsTableAnchors.prototype.scrollToIndicator = function (hash){
	var classname = ".anchor-" + hash.substring(1);
	var $mainAnchorTh = $("table.stat.main-table " + classname);
	var $allAnchorsTh = $("table.stat " + classname);

	if($mainAnchorTh.length > 0){
		var offset = $(".top-header").height();
		var scrollTop = $mainAnchorTh.parents('.tables-wrap').offset().top - offset + $mainAnchorTh.position().top - $mainAnchorTh.parents("table").find("thead").height();
		$(window).scrollTop(scrollTop);

		setTimeout(function(){
			var offset = $(".top-header").height();
			var scrollTop = $mainAnchorTh.parents('.tables-wrap').offset().top - offset + $mainAnchorTh.position().top - $mainAnchorTh.parents("table").find("thead").height();
			$(window).scrollTop(scrollTop);
			setTimeout(function () {
				$allAnchorsTh.parents("tr").removeClass("highlight");
			}, 3000)
		}, 500);
	}
}
//=======================================================================
function StatisticsTableSettings($statisticsWrap, tableScroll, opt_opts){
	opt_opts = opt_opts || {};
	var that = this;
	this.tableScroll = tableScroll;
	this.$statisticsWrap = $statisticsWrap;
	this.$settingsContainer = this.$statisticsWrap.find(".stats-tbl-settings");
	this.$filtersContainer = this.$statisticsWrap.find(".stats-tbl-filters");
	this.$archiveContainer = this.$statisticsWrap.find(".stats-tbl-archive");
	this.fieldsSettings = {};
	this.tableId = this.$statisticsWrap.data("table");
	this.url = this.$statisticsWrap.data("url");
	this.$tableSettingsBtn = this.$statisticsWrap.find(".stats-tbl-settings-toggle");
	this.$tableFiltersBtn = this.$statisticsWrap.find(".stats-tbl-filters-toggle");
	this.$tableArchiveBtn = this.$statisticsWrap.find(".stats-tbl-archive-toggle");


	this.$tableSettingsBtn.click(function(e){
		that.closeOthers(that.$settingsContainer);
		that.toggleTableSettings();
	});

	this.$tableArchiveBtn.click(function(e){
		that.closeOthers(that.$archiveContainer);
		that.toggleTableArchive();
	});


	this.$tableFiltersBtn.click(function(e){
		that.closeOthers(that.$filtersContainer);
		that.toggleTableFilterts();
	});
	this.$filtersContainer.find('.filter-collapse').click(function(e){
		that.closeOthers(null);
	});
	this.$settingsContainer.on('click', '.filter-collapse', function(e){
		that.closeOthers(null);
	});
	this.$archiveContainer.on('click', '.filter-collapse', function(e){
		that.closeOthers(null);
	});
}
StatisticsTableSettings.prototype.closeOthers = function($except){
	var that = this;
	if($except != that.$settingsContainer && that.$settingsContainer.hasClass("active")){
		that.closeTableSettings();
	}

	if($except != that.$archiveContainer && that.$archiveContainer.hasClass("active")){
		that.toggleTableArchive();
	}

	if($except != that.$filtersContainer && that.$filtersContainer.hasClass("active")){
		that.toggleTableFilterts();
	}
}
StatisticsTableSettings.prototype.toggleTableArchive = function(){
	var that = this;
	if(that.$archiveContainer.hasClass("active")){
		that.$archiveContainer.removeClass("active");
		that.$tableArchiveBtn.removeClass("active");
	}else{
		that.$archiveContainer.addClass("active");
		that.$tableArchiveBtn.addClass("active");

		var y = ((window.innerWidth >= 768) && (window.innerWidth <= 1024)) ? -70 : -50;
		$.scrollTo(that.$tableArchiveBtn, 500, { offset: { top:y-17 } });
	}
}
StatisticsTableSettings.prototype.toggleTableFilterts = function(){
	var that = this;
	if(that.$filtersContainer.hasClass("active")){
		that.$filtersContainer.removeClass("active");
		that.$tableFiltersBtn.removeClass("active");
	}else{
		that.$tableFiltersBtn.addClass("active");
		that.$filtersContainer.addClass("active");

		var y = ((window.innerWidth >= 768) && (window.innerWidth <= 1024)) ? -70 : -50;
		$.scrollTo(that.$tableFiltersBtn, 500, { offset: { top:y-17 } });
	}
}

StatisticsTableSettings.prototype.toggleTableSettings = function(){
	var that = this;
	if(that.$settingsContainer.hasClass("active")){
		that.closeTableSettings();
	}else{
		that.openTableSettings();

		var y = ((window.innerWidth >= 768) && (window.innerWidth <= 1024)) ? -70 : -50;
		$.scrollTo(that.$tableSettingsBtn, 500, { offset: { top:y-17 } });
	}
}
StatisticsTableSettings.prototype.closeTableSettings = function(){
	var that = this;
	that.$settingsContainer.removeClass("active");
	that.$tableSettingsBtn.removeClass("active");
	that.$settingsContainer.html('');
}
StatisticsTableSettings.prototype.openTableSettings = function(){
	var that = this;
	that.$tableSettingsBtn.find("i.fa").addClass("fa-spin");
	$.ajax({
		type: "POST",
		url: that.url + "/settings_table",
		data: {
			id: that.tableId
		},
		success: function (response) {
			if(that.$tableFiltersBtn.hasClass("active")){
				that.toggleTableFilterts();
			}

			that.$tableSettingsBtn.addClass("active");
			that.$tableSettingsBtn.find("i.fa").removeClass("fa-spin");
			that.$settingsContainer.html(response);
			that.$settingsContainer.addClass("active");


			that.$settingsContainer.find(".nav-tabs > li").first().find('a.nav-link').addClass("active");
			that.$settingsContainer.find(".tab-content > .tab-pane").first().addClass("show active");


			$(".table-sortable-fields").each(function (){
				new Sortable(this, {
					group: 'fields',
					animation: 100,
					onEnd: function(/**Event*/evt) {
					}
				});
			})
			CmsSelect2.init(that.$settingsContainer)

			that.$settingsContainer.find(".tbl-fld .edit-btn").click(function(e){
				e.preventDefault();
				$(this).find("i.fa").removeClass("fa-pencil").addClass("fa-cog fa-spin");
				that.openTableFieldSettings($(this).parent());
			});

			that.$settingsContainer.find("#applySettings").click(function(e){
				e.preventDefault();
				$(this).find("i.fa").removeClass("fa-floppy-o").addClass("fa-cog fa-spin");
				that.applySettings();
			});
			that.$settingsContainer.find("#resetSettings").click(function(e){
				e.preventDefault();
				$(this).find("i.fa").removeClass("fa-undo").addClass("fa-cog fa-spin");
				$.ajax({
					type: "POST",
					url: that.url + "/reset_settings_table",
					data: {
						id: that.tableId,
					},
					success: function (response) {
						if(response == "ok"){
							location.reload();
						}
					}
				})
			});
		}
	});
}
StatisticsTableSettings.prototype.openTableFieldSettings = function($field){
	var that = this;
	var applySettings = false;
	$.ajax({
		type: "POST",
		url: this.url + "/fieldsettings_table",
		data: {
			id: that.tableId,
			field_id: $field.data("id")
		},
		success: function (response) {

			$field.find(".edit-btn i.fa").addClass("fa-pencil").removeClass("fa-cog fa-spin");

			$.fancybox.open({
				src: response,
				type: 'html',
				minWidth: 600,
				afterClose: function(){
					if(applySettings){
						that.$settingsContainer.find("#applySettings").click();
					}
				},
				afterShow: function(e){
					var fieldId = $("#field-settings").data("field");

					if(that.fieldsSettings[fieldId]){
						if(that.fieldsSettings[fieldId].selectedValues){
							for(var k in that.fieldsSettings[fieldId].selectedValues){
								var name = that.fieldsSettings[fieldId].selectedValues[k];
								$("#field-settings .dim-values input[name='"+name+"']").prop('checked', true).parent().addClass("checked");
							}
						}
						if(that.fieldsSettings[fieldId].options){
							for(var k in that.fieldsSettings[fieldId].options){
								var val = that.fieldsSettings[fieldId].options[k];
								switch(availableOptions[k].type){
									case "checkbox":
										if(val == 1){
											$("#field_opt_"+k).prop('checked', 1).parent().addClass("checked");
										}
										break;
									case "select2":
										$("#field_opt_"+k).select2("val", val);
										break;
									default:
										$("#field_opt_"+k).val(val);
										break;
								}
							}
						}
					}

					$("#applyFldSettings").click(function(e){
						e.preventDefault();
						var options = {};
						for(var optionId in availableOptions){
							switch (availableOptions[optionId].type){
								case "checkbox":
									if($("#field_opt_"+optionId).prop("checked")){
										options[optionId] = true;
									}
									break;
								default:
									options[optionId] = $("#field_opt_"+optionId).val();
									break;
							}
						}
						var dimValues = [];
						$("#field-settings .dim-values input[type='checkbox']:checked").each(function(){
							dimValues.push(this.name);
						});

						if(!that.fieldsSettings[fieldId]){
							that.fieldsSettings[fieldId] = {};
						}

						that.fieldsSettings[fieldId].options = options;
						if(dimValues.length > 0){
							that.fieldsSettings[fieldId].selectedValues = dimValues;
						}
						applySettings = true;
						$.fancybox.close();
					});
					$("#resetFldSettings").click(function(e){
						e.preventDefault();
						that.fieldsSettings[fieldId] = "reset";
						applySettings = true;
						$.fancybox.close();
					});
				}
			})
		}
	});
}
StatisticsTableSettings.prototype.applySettings = function(){
	var that = this;
	var layout = {
		rows: {},
		columns: {},
		values: {},
		settings: {}
	};
	that.$settingsContainer.find(".table-rows .tbl-fld").each(function(){
		var fieldId = $(this).data("id");
		if(that.fieldsSettings[fieldId]){
			layout.rows[fieldId] = that.fieldsSettings[fieldId];
		}else{
			layout.rows[fieldId] = {};
		}

	});
	that.$settingsContainer.find(".table-columns .tbl-fld").each(function(){
		var fieldId = $(this).data("id");
		if(that.fieldsSettings[fieldId]){
			layout.columns[fieldId] = that.fieldsSettings[fieldId];
		}else{
			layout.columns[fieldId] = {};
		}
	});
	//
	that.$settingsContainer.find("#value input[type='checkbox']").each(function(){
		if(this.name){
			var nameParts = this.name.split("-");
			if(!layout.values[nameParts[1]]){
				layout.values[nameParts[1]] = {};
			}
			layout.values[nameParts[1]][nameParts[2]] = this.checked;
		}
	});
	that.$settingsContainer.find("#value select").each(function(){
		if(this.name){
			var nameParts = this.name.split("-");
			if(!layout.values[nameParts[1]]){
				layout.values[nameParts[1]] = {};
			}
			layout.values[nameParts[1]][nameParts[2]] = this.value;
		}
	});
	//
	that.$settingsContainer.find("input[type='checkbox']").each(function(){
		if(this.name){
			var nameParts = this.name.split("-");
			layout.settings[nameParts[1]] = this.checked;
		}
	});


	$.ajax({
		type: "POST",
		url: that.url + "/settings_table",
		data: {
			id: that.tableId,
			layout: JSON.stringify(layout),
		},
		success: function (response) {
			if(response == "ok"){
				location.reload();
			}
		}
	})
}
function StatisticsPreloader($statisticsWrap, tableScroll, opt_opts){
	opt_opts = opt_opts || {};
	var that = this;
	this.tableScroll = tableScroll;

	this.$statisticsWrap = $statisticsWrap;
	this.$tableTBody = this.tableScroll.find("tbody");
	this.$sideFixedTableTBody = $statisticsWrap.find(".evin-fixed-wrap.side > table tbody")
	this.preloadPositionThreshold = opt_opts.optimalTableH || -300;
	this.preloadingData = false;
	this.allPreloadingDataDone = true;//all data loaded
	this.$tableDataPreloader = $('<div class="table-data-preloader"><em class="fa fa-cog fa-spin fa-3x fa-fw"></em></div>');
	this.tableId = this.$statisticsWrap.data("table");

	this.onWindowScroll = function () {
		that.checkScrollPositionForMoreData();
	}

	this.checkToPreloadMore();
}
StatisticsPreloader.prototype.checkToPreloadMore = function(){
	var that = this;
	var $trMore = that.$tableTBody.find("tr.more");
	if($trMore.length){
		$trMore.remove();
		$(window).on("scroll", that.onWindowScroll);
	}else{
		$(window).off("scroll", that.onWindowScroll);
	}
}
StatisticsPreloader.prototype.checkScrollPositionForMoreData = function(){
	var that = this;
	if(this.preloadingData) return;

	var bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop;
	if((window.innerHeight+bodyScrollTop)-(that.tableScroll.offset().top+that.tableScroll.height()) > this.preloadPositionThreshold){
		this.preloadTableData();
	}
}
StatisticsPreloader.prototype.preloadTableData = function() {
	var that = this;
	this.preloadingData = true;
	this.$tableDataPreloader.addClass("active");
	this.tableScroll.parents(".evin-wrap").after(this.$tableDataPreloader);

	var post_data = {
		id: that.tableId,
		currentTrNr: that.tableScroll.find("tbody > tr:last-child").data("nr")
	}

	//filters
	var filters = that.tableScroll.data("filters");
	if(filters){
		for(var k in filters){
			post_data[k] = filters[k];
		}
	}

	$.ajax({
		type: "POST",
		url: this.url + "/preload_table_data",
		data: post_data,
		success: function (response) {
			that.preloadingData = false;
			that.$tableDataPreloader.removeClass("active").remove();
			var $newTrs = $(response).filter("tr");
			that.$tableTBody.append($newTrs);

			that.tableScroll.redrawSide();
			that.tableScroll.update();

			that.checkToPreloadMore();

		}
	});
}
//============================================================================
function TableTreeToggle($statisticsWrap, tableScroll, opt_opts){
	opt_opts = opt_opts || {};
	var that = this;
	this.tableScroll = tableScroll;
	this.$statisticsWrap = $statisticsWrap;
	this.$tableTBody = this.tableScroll.find("tbody");
	this.$sideFreezeTableTBody = $statisticsWrap.find(".evin-fixed-wrap.side > table tbody")

	this.tableScroll.parents(".evin-wrap").on("click", ".tree-children-toggle", function(){
		var trIndex = $(this).parents("tr").index();
		that.toggleChildrens(trIndex);
	})
}
TableTreeToggle.prototype.toggleChildrens = function(trIndex){
	var that = this;

	that.toggleRowChildrens(that.$tableTBody.find("tr:eq("+trIndex+")"));
	that.toggleRowChildrens(that.$sideFreezeTableTBody.find("> tr:eq("+trIndex+")"));

	that.tableScroll.update();
}
TableTreeToggle.prototype.toggleRowChildrens = function($row){
	var that = this;
	var $toggle = $row.find("th .tree-children-toggle")
	var rowLevel = $row.data("level");
	var $nextRow = $row.next();
	var hideChildrens = $toggle.find(".fa").hasClass('fa-minus-square-o');

	if(hideChildrens){
		$toggle.find(".fa").removeClass('fa-minus-square-o').addClass('fa-plus-square-o');
	}else{
		$toggle.find(".fa").removeClass('fa-plus-square-o').addClass('fa-minus-square-o');
	}
	while($nextRow.data("level") > rowLevel){
		if(hideChildrens){
			$nextRow.hide();
		}else{
			$nextRow.show();
			$nextRow.find(".tree-children-toggle .fa").removeClass('fa-plus-square-o').addClass('fa-minus-square-o');
		}
		$nextRow = $nextRow.next();
	}
}
//==================================================
function StatisticsSorting($statisticsWrap, tableScroll, opt_opts){
	opt_opts = opt_opts || {};
	var that = this;
	this.tableScroll = tableScroll;
	this.$statisticsWrap = $statisticsWrap;
	this.$tableTBody = this.tableScroll.find("tbody");
	this.$sideFixedTableTBody = $statisticsWrap.find(".evin-fixed-wrap.side > table tbody")
	this.sortingField = 'date';

	setTimeout(function(){
		that.initSorting();
	}, 300);
}
StatisticsSorting.prototype.initSorting = function (){
	var that = this;
	var default_sorting_field = that.tableScroll.data("default_sorting_field");
	var default_sorting_direction = that.tableScroll.data("default_sorting_direction");

	$(".sortable", this.$statisticsWrap).click(function(e){
		if($(e.target).hasClass("info-i") || $(e.target).parent().hasClass("info-i")) return;

		var $sortable = $(this);
		var newSorting = "asc";
		if($sortable.hasClass("sort-asc")){
			newSorting = "desc";
		}else if($sortable.hasClass("sort-desc")){
			newSorting = "none";
		}
		that.sortTable($sortable, newSorting);
	});


	if(default_sorting_field){
		var sortingDirection = "none";
		if(default_sorting_direction && default_sorting_direction != sortingDirection){
			sortingDirection = default_sorting_direction;
		}
		if(sortingDirection != "none"){
			if(default_sorting_field == "row_header"){
				var $sortable = $(".corner.sortable");
			}else{
				var $sortable = $(".sortable[data-sorting-field='"+default_sorting_field+"']");
			}
			that.sortingField = $sortable.data("sorting-field");
			that.$statisticsWrap.find(".sortable").removeClass("sort-none sort-asc sort-desc");
			that.$statisticsWrap.find(".sortable[data-sorting-field='"+that.sortingField+"']").addClass("sort-" + sortingDirection);

			that.sortTable(that.$statisticsWrap.find(".sortable[data-sorting-field='"+that.sortingField+"']"), sortingDirection);

		}

	}
}
StatisticsSorting.prototype.cacheSortingData = function (){
	var that = this;
	var $trs = that.$tableTBody.find("tr").each(function(){
		var $tr = $(this);
		var sData = {};
		$tr.find(">td,>th").each(function(){
			if($(this).data("sorting-field")){
				if(typeof($(this).data("sorting-value")) == 'undefined'){
					sData[$(this).data("sorting-field")] = -9007199254740992;
				}else{
					sData[$(this).data("sorting-field")] = $(this).data("sorting-value");
				}

			}
		});
		$tr.data("sData", sData);
	});
	that.tableScroll.data("trs", $trs);
}
StatisticsSorting.prototype.sortTable = function ($sortable, direction){

	var that = this;
	if(!that.tableScroll.data("trs") || that.$tableTBody.find("tr").length != that.tableScroll.data("trs").length){
		that.cacheSortingData();
	}

	var $trs = that.tableScroll.data("trs");

	that.sortingField = $sortable.data("sorting-field");
	that.$statisticsWrap.find(".sortable").removeClass("sort-none sort-asc sort-desc");
	//$sortable.addClass("sort-" + direction);
	that.$statisticsWrap.find(".sortable[data-sorting-field='"+that.sortingField+"']").addClass("sort-" + direction);


	var $tbody = that.tableScroll.find("tbody");
	var trs = [];
	$trs.each(function(){
		trs.push($(this));
	});
	if(direction == "asc"){
		trs = trs.sort(function(a, b){
			if(a.data("sData")[that.sortingField] == b.data("sData")[that.sortingField]){
				return 0;
			}else if(a.data("sData")[that.sortingField] > b.data("sData")[that.sortingField]){
				return 1
			}else{
				return -1
			}
		});
	}else if(direction == "desc"){
		trs = trs.sort(function(a, b){
			if(a.data("sData")[that.sortingField] == b.data("sData")[that.sortingField]){
				return 0;
			}else if(a.data("sData")[that.sortingField] > b.data("sData")[that.sortingField]){
				return -1
			}else{
				return 1
			}
		});
	}

	trs.forEach(function(element){
		$tbody.append(element);
	});

	if(that.$sideFixedTableTBody.length){
		trs.forEach(function(element){
			var nr = element.data("nr");
			that.$sideFixedTableTBody.append( that.$sideFixedTableTBody.find("tr[data-nr='"+nr+"']") );
		});
	}
}
//==================================================
function StatisticsSearch($statisticsWrap, tableScroll, opt_opts){
	opt_opts = opt_opts || {};
	var that = this;
	that.kayupTimeoutId = null;
	that.originQuery = '';
	this.tableScroll = tableScroll;
	this.$statisticsWrap = $statisticsWrap;
	this.$table = $statisticsWrap.find(".main-table");
	this.$sideFreezeTable = $statisticsWrap.find(".evin-fixed-wrap.side > table");
	this.$tablesQuery = this.$statisticsWrap.find(".filter_form input[name='query']");


	if(this.$tablesQuery.length){
		this.$clearBtn = this.$statisticsWrap.find(".filter_form a.clear");
		this.markOptions = {};
		this.$tablesQuery.on("keyup", function(e){
			clearTimeout(that.kayupTimeoutId)
			that.kayupTimeoutId = setTimeout(function () {
				that.queryRows();
			}, 1000);

		});
		this.$clearBtn.click(function(){
			that.clearQuery();
		});

		that.originQuery = this.$tablesQuery.val();

		if(that.originQuery.length > 0){
			this.$tablesQuery.parent().addClass("has-feedback");
			this.$table.find("tbody > tr > th .l").unmark().mark(that.originQuery, that.markOptions);
		}
	}
}
StatisticsSearch.prototype.queryRows = function(){
	var that = this;
	var q = this.$tablesQuery.val();

	if(q.length > 1 || (q.length == 0 && that.originQuery.length > 0)){
		$(this.$tablesQuery[0].form).submit();
	}
}
StatisticsSearch.prototype.clearQuery = function(){
	var that = this;
	that.$tablesQuery.val('');
	that.queryRows();
}

export { StatisticsSearch, TableTreeToggle, StatisticsSorting, StatisticsPreloader, StatisticsTableSettings, StatisticsTableAnchors, StatisticsTableMarking }